<div class="json-editor-container">
  <div class="json-editor-content">
  
    <div class="editor-container" style="margin-bottom: 10px;">
    
      <!-- Read-Only JSON Editor -->
      <div class="editor" *ngIf="jsonReadOnlyData">
        <h3>{{readonlyPanelLabel | translate}}</h3>
        <json-editor *ngIf="jsonReadOnlyData" #reaOnlyJson [data]="jsonReadOnlyData" [options]="jsonReadOnlyOptions"></json-editor>
      </div>
      <!-- Editable JSON Editor -->
      <div class="editor">
        <h3>{{editablePanelLabel | translate}}</h3>
        <json-editor  #editableJson [data]="jsonData" [options]="jsonEditableOptions" (change)="changeData($event)"></json-editor>
      </div>
    
    </div></div>
    <div>
      <p-footer style="background-color: white;">
        <button pButton label="Save"  [disabled]="jsonEditorComponent != undefined && !jsonEditorComponent.isValidJson()" class="t-button-outline" icon="pi pi-save" (click)="saveJson()"></button>
        <button pButton label="Cancel" class="t-button-outline" icon="pi pi-times" (click)="cancelJson()"></button>
      </p-footer>
      </div>
  </div>